import { gql } from '@apollo/client';

export const UPDATE_FRIST_GELESEN = gql`
  mutation navigation_updateFristGelesen(
    $input: navigation_updateFristGelesenInput!
  ) {
    navigation_updateFristGelesen(input: $input)
  }
`;

export const UPDATE_SCHICHTTAUSCHANTRAG = gql`
  mutation navigation_updateSchichttauschantrag(
    $input: navigation_updateSchichttauschInput!
  ) {
    navigation_updateSchichttauschAntrag(
      updateSchichttauschAntragInput: $input
    ) {
      success
      error {
        message
        ... on navigation_ManagerNotFound {
          id
        }
        ... on navigation_SchichttauschantragUpdateSchichttauschAntragNotFound {
          id
        }
        ... on navigation_SchichttauschantragUpdateSettingNotActivated {
          id
        }
        ... on navigation_SchichttauschantragUpdateStatusNotSupported {
          status
        }
        ... on navigation_SchichttauschantragUpdateTauschpartnerMissing {
          details
        }
        ... on navigation_SchichttauschantragUpdateTauschpartnerIllegal {
          id
        }
      }
    }
  }
`;
